import { DownloadIcon, PrintIcon } from '@wonderschool/common-base-ui';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type ExportToolbarProps = {
  onExportPDF?: () => void;
  onExportCSV?: () => void;
  disabled?: boolean;
  pdfLabel?: string;
  pdfSubLabel?: string;
  csvLabel?: string;
};

const ExportToolbar: React.FC<ExportToolbarProps> = ({
  onExportPDF,
  onExportCSV,
  disabled,
  pdfLabel,
  pdfSubLabel,
  csvLabel,
}) => {
  const { t } = useTranslation();

  const disabledClasses = `text-gray-300 cursor-default hover:text-gray-300`;
  const enabledClasses = `text-blue-900 hover:text-blue-600 font-bold cursor-pointer`;

  if (!onExportPDF && !onExportCSV) return null;

  return (
    <div className={'mt-2 flex h-full flex-row items-center justify-end gap-5'}>
      {!!onExportPDF && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href="#"
          className={twMerge(disabled ? disabledClasses : enabledClasses, 'flex flex-col items-center')}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            } else if (onExportPDF) {
              onExportPDF();
            }
          }}
          data-testid="export-print-button"
        >
          <PrintIcon data-testid="print-icon" className="mr-0.5 size-8" />
          {pdfLabel ?? t('reports.exportToolbar.printAction')}
          {!!pdfSubLabel && <span className="mt-0.5 text-center text-xs font-normal">{pdfSubLabel}</span>}
        </a>
      )}
      {!!onExportCSV && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a
          href="#"
          className={twMerge(disabled ? disabledClasses : enabledClasses, 'flex flex-col items-center')}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault();
            } else if (onExportCSV) {
              onExportCSV();
            }
          }}
          data-testid="export-download-button"
        >
          <DownloadIcon data-testid="download-icon" className="mr-0.5 size-8" />
          {csvLabel ?? t('reports.exportToolbar.downloadAction')}
        </a>
      )}
    </div>
  );
};
export default ExportToolbar;
